import { Box, Typography, Stack } from "@mui/material";
import { colors } from "../../theme/muiColors";
import { format } from "date-fns";
import BatteryStdIcon from "@mui/icons-material/BatteryStd";
import SensorsIcon from "@mui/icons-material/Sensors";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { styleConfig } from "../../config";

export const RecordInfo = ({ record }) => {
  if (!record) return null;

  const primary = styleConfig?.tabItemStyles?.primary?.color || colors.blue[500];

  // Función auxiliar para validar y formatear la fecha de forma segura
  const formatDate = (dateValue) => {
    if (!dateValue) return "Fecha no disponible";

    try {
      const date = new Date(dateValue);
      // Validar que la fecha es válida
      if (isNaN(date.getTime())) {
        return "Fecha inválida";
      }
      return format(date, "PPpp");
    } catch (error) {
      console.error("Error formatting date:", error, "Date value:", dateValue);
      return "Fecha inválida";
    }
  };

  return (
    <Box sx={{ minWidth: 220 }}>
      <Stack direction="row" spacing={1} alignItems="center" mb={1}>
        <AccessTimeIcon fontSize="small" sx={{ color: primary }} />
        <Typography variant="subtitle2">{formatDate(record.createdAt)}</Typography>
      </Stack>

      {record.battery !== undefined && (
        <Stack direction="row" spacing={1} alignItems="center" mb={0.5}>
          <BatteryStdIcon fontSize="small" sx={{ color: colors.green[500] }} />
          <Typography variant="body2">{record.battery}% battery</Typography>
        </Stack>
      )}

      {record.motion && (
        <Stack direction="row" spacing={1} alignItems="flex-start" mt={1}>
          <SensorsIcon fontSize="small" sx={{ color: colors.orange[500], mt: 0.2 }} />
          <Box>
            {/* Aceleración */}
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
              Acceleration (m/s²)
            </Typography>
            <Stack direction="row" spacing={2} ml={1}>
              {["x", "y", "z"].map((axis) => (
                <Typography key={`acc-${axis}`} variant="body2" sx={{ fontWeight: 500 }}>
                  {axis.toUpperCase()}: {record.motion.acceleration[axis].toFixed(2)}
                </Typography>
              ))}
            </Stack>

            {/* Giroscopio */}
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
              Gyroscope (°/s)
            </Typography>
            <Stack direction="row" spacing={2} ml={1}>
              {["x", "y", "z"].map((axis) => (
                <Typography key={`gyro-${axis}`} variant="body2" sx={{ fontWeight: 500 }}>
                  {axis.toUpperCase()}: {record.motion.gyro[axis].toFixed(2)}
                </Typography>
              ))}
            </Stack>
          </Box>
        </Stack>
      )}
    </Box>
  );
};
